(function(){
  var MAP={
    'all7-lions-mane-mushroom':{v:'https://cdn.shopify.com/videos/c/vp/340baaff0ac14cee84e8bd94dfcf80d2/340baaff0ac14cee84e8bd94dfcf80d2.HD-720p-2.1Mbps-86346934.mp4',n:"Lion's Mane",s:'2000mg of 10:1 dual-extracted Lion’s Mane per spoon. Stir it into coffee, smoothies or meals — ten seconds, done.'},
    'all7-turkey-tail-mushroom':{v:'https://d8j0ntlcm91z4.cloudfront.net/user_3EeZxUPfsLEUgltTnT7I94EDyYS/hf_20260622_081857_970fef91-830c-4e32-a1ce-80a1d1330baf.mp4',n:'Turkey Tail',s:'2000mg of 10:1 dual-extracted Turkey Tail per spoon. Stir it into coffee, smoothies or meals — ten seconds, done.'},
    'all7-reishi-mushroom':{v:'https://d8j0ntlcm91z4.cloudfront.net/user_3EeZxUPfsLEUgltTnT7I94EDyYS/hf_20260622_083452_dc57a782-f5cb-4d2e-b824-94305a91f812.mp4',n:'Reishi',s:'2000mg of 10:1 dual-extracted Reishi per spoon. Stir it into a warm drink before bed — ten seconds, done.'},
    'all7-cordyceps-mushroom':{v:'https://d8j0ntlcm91z4.cloudfront.net/user_3EeZxUPfsLEUgltTnT7I94EDyYS/hf_20260622_083454_fd607077-dc4a-4e46-acbf-1a8cf6ada61a.mp4',n:'Cordyceps',s:'2000mg of 10:1 dual-extracted Cordyceps per spoon. Stir it in before training — ten seconds, done.'},
    'all7-lions-mane-powder-gummies-bundle':{v:'https://cdn.shopify.com/videos/c/vp/7541c48109674e84bfc62d52f15bc4d3/7541c48109674e84bfc62d52f15bc4d3.HD-720p-1.6Mbps-86347387.mp4',n:"Lion's Mane",s:'Powder for the morning, gummies for the day. One spoon plus two gummies — focus covered, all day.'}
  };
  function handle(){var m=location.pathname.match(/\/products\/([^\/?#]+)/);return m?m[1]:'';}
  function place(){
    var el=document.querySelector('.a7mo');
    var sec=el?el.closest('.shopify-section'):null;
    if(!sec)return;
    var cfg=MAP[handle()];
    if(!cfg){sec.style.display='none';return;}
    var v=sec.querySelector('.a7mo-v');
    if(v&&!v.getAttribute('src')){
      v.setAttribute('src',cfg.v);v.muted=true;v.load();
      var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(!reduce){
        var kick=function(){if(v.paused){var p=v.play();if(p&&p.catch)p.catch(function(){});}};
        v.addEventListener('pause',function(){if(document.visibilityState==='visible'){setTimeout(kick,150);}});
        [400,1200,2500,5000].forEach(function(t){setTimeout(kick,t)});
        if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)kick();});},{threshold:.25}).observe(v);}
        document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')setTimeout(kick,200);});
        kick();
      }
    }
    var sub=sec.querySelector('[data-a7mo-sub]');
    if(sub)sub.textContent=cfg.s;
    var bens=document.querySelector("[id$='policies_block_FFNwwc']");
    var main=document.getElementById('MainContent');
    if(bens&&bens.parentElement){bens.insertAdjacentElement('afterend',sec);}
    else if(main){main.appendChild(sec);}
    sec.style.display='';sec.style.width='100%';
  }
  /* theme "You May Also Like" mixes LIVE + -packs products on test pages.
     Fix (run-once): unslick the carousel to a static grid, rewrite live-handle
     cards to their -packs twins, drop true duplicates + self.
     NEVER slickRemove: slick hangs in an infinite clone loop when count < slidesToShow. */
  var TWIN={'all7-lions-mane-mushroom':'all7-lions-mane-mushroom-packs','all7-lion-s-mane-gummies':'all7-lion-s-mane-gummies-packs','all7-cordyceps-mushroom':'all7-cordyceps-mushroom-packs','all7-reishi-mushroom':'all7-reishi-mushroom-packs','all7-turkey-tail-mushroom':'all7-turkey-tail-mushroom-packs','all7-lions-mane-powder-gummies-bundle':'focus-starter-kit-packs'};
  var dedupeDone=false,recObs=null;
  function dedupe(){
    if(dedupeDone)return;
    if(!MAP[handle()])return;
    var sec=document.querySelector("[id$='__product-recommendations']");
    if(!sec)return;
    var items=[].slice.call(sec.querySelectorAll('.product-item'));
    var hydrated=items.some(function(it){return it.querySelector('a[href*="/products/"]')});
    if(!hydrated)return;
    dedupeDone=true;if(recObs){recObs.disconnect();recObs=null;}
    var track=sec.querySelector('.slick-initialized');
    if(track&&window.jQuery){try{window.jQuery(track).slick('unslick');}catch(e){}}
    var seen={};
    items=[].slice.call(sec.querySelectorAll('.product-item'));
    items.forEach(function(it){
      var li=it.closest('li')||it;
      if(it.closest('.slick-cloned')){if(li.parentElement)li.parentElement.removeChild(li);return;}
      var a=it.querySelector('a[href*="/products/"]');if(!a)return;
      var h=a.pathname.split('/').pop();
      var target=TWIN[h]||h;
      if(target===handle()||seen[target]){if(li.parentElement)li.parentElement.removeChild(li);return;}
      seen[target]=1;
      if(target!==h){[].forEach.call(it.querySelectorAll('a[href*="/products/"]'),function(l){l.setAttribute('href','/products/'+target);});}
    });
    var fi=sec.querySelector('.product-item');
    if(fi){var li=fi.closest('li');var list=li?li.parentElement:fi.parentElement;if(list)list.classList.add('a7-recfix');}
  }
  function watchRecs(){
    if(!MAP[handle()])return;
    var sec=document.querySelector("[id$='__product-recommendations']");
    if(sec&&'MutationObserver' in window){recObs=new MutationObserver(function(){if(!dedupeDone)setTimeout(dedupe,80);});recObs.observe(sec,{childList:true,subtree:true});}
    [1000,2500,4500,7500,11000].forEach(function(t){setTimeout(dedupe,t)});
  }
  function boot(){place();/* watchRecs() DISABLED Jun16 — "you may also like" is now server-rendered via snippets/a7-recs.liquid */}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
